import { Input } from '@1trading/react/components/ui/input';
import { cn } from '@1trading/react/lib/utils';
import React, { type ComponentProps } from 'react';

import useDynamicGoogleFont from '@/hooks/use-dynamic-google-font';

const SignatureInput = React.forwardRef(({ className, style, ...props }: ComponentProps<typeof Input>, ref: React.Ref<HTMLInputElement>) => {
  const { style: fontStyle } = useDynamicGoogleFont('Alex Brush');

  return <Input className={cn('py-0 text-2xl', className)} ref={ref} style={{ ...style, ...fontStyle }} {...props} />;
});
SignatureInput.displayName = 'SignatureInput';

export default SignatureInput;
